module.exports = __webpack_public_path__ + "static/media/empty-search-contact.82429ffb.png";